module.exports = {
	"analyticsData": "track",
	"buckets": 20,
	"validEvars": [
		66,
		67,
		68
	],
	"cookies": {
		"bucketCookieName": "testBucket",
		"monetateCookieName": "testMonetate",
		"rdpCookieName": "bby_rdp",
		"domain": ".bestbuy.com",
		"expiration": "2017-01-28T23:59:59-06:00"
	},
	"testMode": {
		"QA": "qa"
	},
	"testType": {
		"BACKEND": "backend",
		"SCALED": "scaled",
		"SKU_LIST": "skuList",
		"STANDARD": "standard"
	},
	"testData": "abtTestData",
	"imgServerConfig": "abtImgServerConfig",
	"clientData": {
		"location": "abtestClientData",
		"duration": 60,
		"pages": [
			"browse,list,category",
			"browse,pdp"
		],
		"categories": {
			"abcat0800000": "mobile",
			"abcat0401000": "di",
			"abcat0912000": "smallappl",
			"pcmcat209000050006": "tablets",
			"abcat0500000": "computing",
			"pcmcat332000050000": "wearable",
			"pcmcat300300050002": "xbone",
			"pcmcat295700050012": "ps4",
			"pcmcat273800050036": "wiiu",
			"abcat0700000": "videogames",
			"abcat0715000": "videogameacc"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-core/site-config.json
 ** module id = 2
 ** module chunks = 2 3
 **/